// AI Upgraded Component
import { Component, Input, ChangeDetectionStrategy, OnInit } from '@angular/core';
import { ExtensionService } from '../../services/extension.service';
import { GlobalHelperService } from '@client/app/services/global-helper/global-helper.service';

@Component({
    selector: 'extension-visual-link-button, mon-extension-visual-link-button',
    templateUrl: './visual-link-button.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class ExtensionVisualLinkButtonComponent implements OnInit {
    @Input() type?: string;
    @Input() page: any;
    @Input() data?: any;
    @Input() monDisabled?: boolean;
    @Input() tooltipPlacement?: string;

    loading = true;
    extensionInstalled: boolean | null = null;
    moduleName: string = '';

    constructor (
        private extensionService: ExtensionService,
        private globalHelperService: GlobalHelperService,
    ) {}

    ngOnInit (): void {
        this.tooltipPlacement = this.tooltipPlacement || 'top';
        this.moduleName = this.globalHelperService.getCurrentModule();
        this.extensionService.isInstalled().then(res => {
            this.extensionInstalled = res;
            this.loading = false;

        });
    }

    async onClick (): Promise<void> {
        if (this.monDisabled) {
            return;
        }
        const params: any = { page: this.page };
        if (this.type) {
            params.type = this.type;
        }
        if (this.data) {
            params.data = this.data;
        }
        await this.extensionService.openExtensionDeeplink(params);
    }
}
